import { getPath } from '@mui/system';
import React from 'react';
const svgDashedImage = ({ borderColor = 'rgb(0,0,0)', borderDasharray = '7', borderWidth = 2, borderRadius, borderDashoffset = '0', borderLinecap = 'square' } = {})=>`url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='${borderRadius}' ry='${borderRadius}' stroke='${borderColor}' stroke-width='${borderWidth}' stroke-dasharray='${borderDasharray}' stroke-dashoffset='${borderDashoffset}' stroke-linecap='${borderLinecap}'/%3e%3c/svg%3e");`;
// There is a issue with passing all the custom props to div. I don't know how to do it better because it is not possible to define custom shouldForwardProp
// May be this issue will solve it in future. https://github.com/mui/material-ui/issues/34831
export const WorkaroundComponent = /*#__PURE__*/ React.forwardRef(({ borderColor, borderDasharray, borderWidth, borderDashoffset, borderLinecap, ...other }, ref)=>/*#__PURE__*/ React.createElement("div", {
        ref: ref,
        ...other
    }));
WorkaroundComponent.displayName = 'WorkaroundComponent';
export const dashedVariant = {
    props: {
        variant: 'dashed'
    },
    style: ({ ownerState, theme })=>{
        return {
            ...ownerState?.elevation ? {
                boxShadow: theme.shadows[ownerState.elevation]
            } : {},
            backgroundImage: svgDashedImage({
                ...ownerState,
                borderRadius: `${theme.radius(ownerState.radius)}`,
                borderColor: getPath(theme, `palette.${ownerState.borderColor}`)
            })
        };
    }
};
